import React from 'react';
import _ from 'lodash';
import styles from './BecomeInfluencer.module.scss';
import { Form } from 'semantic-ui-react';
import FSTextInput from '../../form/TextInput';
import FSTextInputMask from '../../form/TextInputMask';
import FSSelectInput from '../../form/SelectInput';
import { countries, states } from '../../../config/supported_areas';
import FSFileInput from '../../form/FileInput';
import FSCheckbox from '../../form/FSCheckbox';

const supportedTypes = [
	'application/pdf',
	'application/msword',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

const IDTypeOptions = [
	{ label: 'Social Security Number (SSN)', value: 'ssn' },
	{ label: 'Employer Identification Number (EIN)', value: 'ein' }
];

const TaxClassificationOptions = [
	{ label: 'Individual/sole proprietor or single-member LLC', value: 'individual' },
	{ label: 'Limited liability company', value: 'llc' },
	{ label: 'C Corporation', value: 'c_corporation' },
	{ label: 'S Corporation', value: 's_corporation' },
	{ label: 'Partnership', value: 'partnership' },
	{ label: 'Trust/estate', value: 'trust_estate' }
];


const AddressPage = ({ needAddress=true, purchaseMembership, hasW9, hasW8 }) => {
	const [country, setCountry] = React.useState('');
	return (
		<div>
			<h2 className={styles.header}>Your Information</h2>
			<Form.Group widths='equal'>
				<FSTextInput name="phone" placeholder="Phone" required />
				<FSTextInputMask name="birthday" placeholder="Birthday" required />
			</Form.Group>
			{ needAddress && (
				<>
					<div className={styles.seperator} />
					<h2 className={styles.header}>Contact Address</h2>
					{purchaseMembership !== null && <p className={styles.subheader}>We will ship your everything card here</p>}
					{/* {purchaseMembership !== null && <FSCheckbox
						className={styles.checkbox}
						name="membership.requestedPhysicalCard"
						label={'Do you want a physical everything card? ($10)'}
						// onChange={(checked) => setShowShippingPage(checked)}
						style={{ fontSize: '15px' }}
					/> } */}
					<Form.Group widths='equal'>
						<FSTextInput name="address.street1" placeholder="Address Line 1" label="Street" required />
					</Form.Group>
					<Form.Group widths='equal'>
						<FSTextInput name="address.street2" placeholder="Address Line 2" label={false} />
					</Form.Group>
					<Form.Group widths='equal'>
						<FSTextInput name="address.city" placeholder="City" required />
						<FSTextInput name="address.state" placeholder="State/Province" required />
					</Form.Group>
					<Form.Group widths='equal'>
						<FSTextInput name="address.zip" placeholder="Postal Code" required />
						<FSSelectInput name="address.country" placeholder="Country" required options={countries} onChange={
							(value) => {
								setCountry(value);
							}
						} />
					</Form.Group>
				</>)}
			{(!hasW9 && country === 'US' ) &&
			<>
				<div className={styles.seperator} />
				<h2 className={styles.header}>W-9 Information</h2>
				<p className={styles.subheader}>Please fill out the W-9 Information Below</p>
				{ /* USPerson, Legal Name, Federal Tax Classification, Taxpayer Identification Number Type, SSN/EIN #, Accepted Terms  */ }
				{/* <Form.Group widths='equal'>
					<FSCheckbox name="w9.usPerson" label="I am a U.S. Person" required />
				</Form.Group> */}
				<Form.Group widths='equal'>
					<FSTextInput name="w9.legalNameOfBusiness" placeholder="Legal Name" required />
				</Form.Group>
				<Form.Group widths='equal'>
					<FSSelectInput
						name="w9.taxClassification"
						label="Federal Tax Classification"
						required
						options={TaxClassificationOptions}
					/>
				</Form.Group>
				<Form.Group widths='equal'>
					<FSSelectInput
						name="w9.idType"
						label="Taxpayer Identification Number Type"
						required
						options={IDTypeOptions}
					/>
				</Form.Group>
				<Form.Group widths='equal'>
					<FSTextInput name="w9.idNumber" placeholder="SSN/EIN #" required />
				</Form.Group>
				<Form.Group widths='equal'>
					<FSCheckbox name="w9.acceptedTerms" label="I certify, under penalties of perjury, that the information above is true and correct." required />
				</Form.Group>
				{/* <a href="https://office.peoplefourpeople.com/public/forms/w9.pdf" target="_blank" download>Click here to download the W-9 form</a>
			<FSFileInput name="file" /> */}
			</>
			}
			{(!hasW8 &&  country && country !== 'US' ) &&
			<>
				<div className={styles.seperator} />
				<h2 className={styles.header}>W-8BEN Information</h2>
				<p className={styles.subheader}>Please fill out the W-8BEN Information Below</p>
				{ /* USPerson, Legal Name, Federal Tax Classification, Taxpayer Identification Number Type, SSN/EIN #, Accepted Terms  */ }
				{/* <Form.Group widths='equal'>
					<FSCheckbox name="w9.usPerson" label="I am a U.S. Person" required />
				</Form.Group> */}
				<Form.Group widths='equal'>
					<FSTextInput name="w8.name" placeholder="Legal Name" required />
				</Form.Group>
				<Form.Group widths='equal'>
					<FSTextInput name="w8.PermanentResidenceAddress" placeholder="Permanent Residence Address" required />
				</Form.Group>
				<Form.Group widths='equal'>
					<FSTextInput name="w8.city" placeholder="city/Town" required />
				</Form.Group>
				<Form.Group widths='equal'>
					<FSTextInput name="w8.USTaxPayerID" placeholder="US TaxPayer ID" required />
				</Form.Group>
				<Form.Group widths='equal'>
					<FSTextInput name="w8.ForeignTaxID" placeholder="Foreign Tax ID" required />
				</Form.Group>
				<Form.Group widths='equal'>
					<FSCheckbox name="w8.FTINRequired" label="Check if FTIN not legally required." required />
				</Form.Group>
				<Form.Group widths='equal'>
					<FSTextInput name="w8.ReferenceNumber" placeholder="Reference Number" required />
				</Form.Group>
				<Form.Group widths='equal'>
					<FSCheckbox name="w8.acceptedTerms" label="I certify, under penalties of perjury, that the information above is true and correct." required />
				</Form.Group>
				{/* <a href="https://office.peoplefourpeople.com/public/forms/w9.pdf" target="_blank" download>Click here to download the W-9 form</a>
			<FSFileInput name="file" /> */}
			</>
			}
		</div>
	);
};

export function validate(values) {
	const errors = { address: {} };

	if(!values.phone) {
		errors.phone = 'Required';
	}

	if(!values.birthday) {
		errors.birthday = 'Required';
	}

	if(!values.address.street1) {
		errors.address.street1 = 'Required';
	}

	if(!values.address.city) {
		errors.address.city = 'Required';
	}

	if(!values.address.zip) {
		errors.address.zip = 'Required';
	}

	if(!values.address.state) {
		errors.address.state = 'Required';
	}

	if(!values.address.country) {
		errors.address.country = 'Required';
	}

	// if(!values.hasW9) {
	// 	if(!values.file) {
	// 		errors.file = 'Please upload the completed W-9';
	// 	} else if(!supportedTypes.includes(_.get(values, 'file.type'))) {
	// 		errors.file = 'Incorrect document type. Please upload a PDF or Word Document';
	// 	}
	// }
	if(!values.hasW9 && values.address.country === 'US') {
		// if(!values.w9 || !values.w9.usPerson) {
		// 	if (!errors.w9) { errors.w9 = {}; }
		// 	errors.w9.usPerson = 'We only support US persons at this time';
		// }

		if(!values.w9 || !values.w9.legalNameOfBusiness) {
			if (!errors.w9) { errors.w9 = {}; }
			errors.w9.legalNameOfBusiness = 'Required Field';
		}

		if(!values.w9 || !values.w9.taxClassification) {
			if (!errors.w9) { errors.w9 = {}; }
			errors.w9.taxClassification = 'Required Field';
		}

		if(!values.w9 || !values.w9.idType) {
			if (!errors.w9) { errors.w9 = {}; }
			errors.w9.idType = 'Required Field';
		}

		if(!values.w9 || !values.w9.idNumber) {
			if (!errors.w9) { errors.w9 = {}; }
			errors.w9.idNumber = 'Required Field';
		}

		if(!values.w9 || !values.w9.acceptedTerms) {
			if (!errors.w9) { errors.w9 = {}; }
			errors.w9.acceptedTerms = 'Please accept the terms';
		}
	}

	if(!values.hasW8 && values.address.country !== "US"){
		if(!values.w8 || !values.w8.name) {
			if (!errors.w8) { errors.w8 = {}; }
			errors.w8.name = 'Required Field';
		}
		if(!values.w8 || !values.w8.PermanentResidenceAddress) {
			if (!errors.w8) { errors.w8 = {}; }
			errors.w8.PermanentResidenceAddress = 'Required Field';
		}
		if(!values.w8 || !values.w8.city) {
			if (!errors.w8) { errors.w8 = {}; }
			errors.w8.city = 'Required Field';
		}
		if(!values.w8 || !values.w8.USTaxPayerID) {
			if (!errors.w8) { errors.w8 = {}; }
			errors.w8.USTaxPayerID = 'Required Field';
		}
		if(!values.w8 || !values.w8.ForeignTaxID) {
			if (!errors.w8) { errors.w8 = {}; }
			errors.w8.ForeignTaxID = 'Required Field';
		}
		if(!values.w8 || !values.w8.ReferenceNumber) {
			if (!errors.w8) { errors.w8 = {}; }
			errors.w8.ReferenceNumber = 'Required Field';
		}
		if(!values.w8 || !values.w8.acceptedTerms) {
			if (!errors.w8) { errors.w8 = {}; }
			errors.w8.acceptedTerms = 'Please accept the terms';
		}
	}

	return errors;
}

export default AddressPage;